import GroupDiscoveryHint from './GroupDiscoveryHint.component';

export default GroupDiscoveryHint;
